<template>
  <div class="wrapper">
    <div class="navigation" :class="{ 'drawer-open': mobileDrawerOpen }" :style="currentRoute === '/Lcd/pickcel/overview' ? 'width:50px !important' : ''">
      <!-- <h1 class="logo">
        <span v-if="MenuLogoImage==='' || MenuLogoImage===undefined || MenuLogoImage===null ">
        <img src="@/assets/img/logo.png" alt="solum esl dashboard" />
        </span>
        <span v-else>
          <img :src="MenuLogoImage" alt="solum esl dashboard" style="width:183px;height:50px" />
        </span>
      </h1>
      <button type="button" class="btn-nav-fold">
        <img src="@/assets/img/expandMenu-small.png" alt="열기" />
      </button> -->
      <!-- 좌측 메뉴 -->
      <Navigator />
    </div>
    <!-- Mobile nav overlay -->
    <div class="mobile-nav-overlay" v-if="mobileDrawerOpen && isMobile" @click="mobileDrawerOpen = false"></div>
    <!-- 우측 콘텐츠 -->
    <div class="contentsWarp" id="contentWrap"
      :style="currentRoute === '/Lcd/pickcel/overview' ? 'width:calc(100% - 50px) !important; margin-left: 50px !important' : ''">
      <!-- 콘텐츠 헤더: 공통 -->
      <header class="header pr-1" id="header" v-if="currentRoute !== '/Lcd/pickcel/overview'">
        <!-- Mobile menu toggle button -->

        <!-- Store 검색창 -->
        <div ref="searchPublicBar" class="d-flex align-center search" style="width: 32%;">
          <button class="btn-mobile-menu" @click="mobileDrawerOpen = !mobileDrawerOpen" aria-label="Toggle navigation">
          <i class="mdi mdi-menu"></i>
        </button>
          <v-form class="d-flex align-center">
            <!-- Store 선택팝업 -->
            <v-btn :disabled="searchPublicBarDisabled" class="btn-search" @click="openSearchStore()" text>
              <img v-show="true" ref="searchIconON" src="@/assets/img/ico-top-search.png" alt="" />
              <img v-show="false" ref="searchIconOFF" src="@/assets/img/ico-top-search-disabled.png" alt="" />
            </v-btn>
            <popupStore :search="searchStore" :dialog_store="dialog_store" @closeMainStoreModal="closeMainStoreModal">
            </popupStore>
            <v-tooltip top :disabled="!isStoreTruncated">
              <template v-slot:activator="{ on, attrs }">
                <v-autocomplete v-bind="attrs" v-on="on" ref="storeAutocomplete"
                  v-model="searchStore" :items="computedStoreItems" :filter="searchStoreFilter"
                  :loading="isLoading" item-text="description" item-value="stores" :search-input.sync="searchStoreLording"
                  :placeholder="`${$t('Select the store')}`" :disabled="searchPublicBarDisabled" return-object clearable
                  append-icon=""
                  clear-icon="mdi-close"
                  class="custom-autocomplete">
                </v-autocomplete>
              </template>
              <span>{{ searchStore && searchStore.description }}</span>
            </v-tooltip>
          </v-form>
        </div>
        <div class="d-flex align-center">
          <v-tooltip top :disabled="!isStoreInfoTruncated">
            <template v-slot:activator="{ on, attrs }">
              <p key="selectedStore" ref="storeInfoRef" class="h_storeInfo" v-bind="attrs" v-on="on">{{ selectedStoreText }}</p>
            </template>
            <span>{{ selectedStoreText }}</span>
          </v-tooltip>
          <!-- 언어선택 -->
          <div class="h_lang drop-down">
            <button type="button" @click="toggleDropdown" class="btn-dropdown" name="language-dropdown">
              {{ currentLanguage }}
            </button>

            <ul class="drop-box custom-scrollBox" style="height:200px;overflow-y:hide">
              <li v-for="(language, index) in languagelist" style="cursor: pointer;padding:10px" :key="language.id"
                @click="setActive(language, index)">
                {{ language.languageName }}
              </li>
            </ul>
            <!-- <ul class="drop-box">
              <li>
                <button type="button" @click="changLanguage('en')">
                  English
                </button>
              </li>
              <li>
                <button type="button" @click="changLanguage('ko')">
                  한국어
                </button>
              </li>
              <li>
                <button type="button" @click="changLanguage('de')">
                  Deutsche
                </button>
              </li>
              <li>
                <button type="button" @click="changLanguage('fr')">
                  Francais
                </button>
              </li>
              <li>
                <button type="button" @click="changLanguage('zh')">
                  中文
                </button>
              </li>
              <li>
                <button type="button" @click="changLanguage('es')">
                  Espanol
                </button>
              </li>
              <li>
                <button type="button" @click="changLanguage('it')">
                  Italiano
                </button>
              </li>
              <li>
                <button type="button" @click="changLanguage('por')">
                  Portugal
                </button>
              </li>
              <li>
                <button type="button" @click="changLanguage('jp')">
                  日本語
                </button>
              </li>
            </ul> -->
          </div>
          <!-- 사용자 정보 -->
          <div class="h_member drop-down">
            <button type="button" @click="toggleDropdown" class="btn-dropdown">
              {{ displayUserId }} <i>{{ user.accountGroup }}</i>
            </button>
            <div class="drop-box">
              <div class="_member">
                <p class="name">{{ user.firstName }}</p>
                <p class="id">(ID : {{ displayUserId }})</p>
              </div>
              <div class="myAccount">
                <router-link :to="{ path: MyAccountLink }">{{
                  $t('My Account')
                }}</router-link>
              </div>
              <div v-if="cloudMode" class="dashboard_ver">
                <p>SoftWare</p>
                <div class="versionInfo">
                  <p>Release Version : {{ user.releaseVersion }}</p>
                  <p>Dashboard : {{ DashBoard_Release }}</p>
                  <p>Core : {{ user.coreRevision }}</p>
                  <p>Portal : {{ user.portalRevision }}</p>
                </div>
              </div>
              <main-software-information v-else />
              <div>
                <v-btn class="btn-logout" @click="onLogout" text width="100%">{{
                  $t('Log out')
                }}</v-btn>
              </div>
              <main-privacy-policy />
            </div>
          </div>
        </div>
      </header>
      <!-- 콘텐츠 -->
      <div class="contents" :style="currentRoute === '/Lcd/pickcel/overview' ? 'padding: 00px !important' : ''">
        <router-view></router-view>
      </div>
    </div>
    <!--Message -->
    <div>
      <!-- <v-dialog v-model="messageDialog" width="300">
        <v-card class="popup add_store_popup" align="center" justify="center">
          <v-row>
            <v-col>
              <span v-text="messageText"></span>
            </v-col>
          </v-row>
          <v-card-actions class="d-flex justify-center">
            <v-btn text icon @click="messageDialog = false" class="btn">{{ $t('OK') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <!-- <v-dialog v-model="messageDialog" width="300" persistent>
             <i class="ico-success"
          ><img src="@/assets/img/ico-caution.png" alt=""
        /></i>
      <v-card class="popup add_store_popup" align="center" justify="center">

    <v-row>
      <v-col class="text-center">
        <div v-if="messageTitle" class="text-h6 mb-2">{{ messageTitle }}</div>
        <span v-text="messageText"></span>
      </v-col>
    </v-row>
    <v-card-actions class="d-flex justify-center">
      <v-btn text icon @click="confirmMessage" class="btn">{{ messageConfirmText }}</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog> -->

 <v-dialog v-model="messageDialog" max-width="300" style="overflow-y: hidden !important;">
    <v-card
        class="popup add_store_popup popup-success"
        align="center"
        justify="center"
        style="border-radius: 5px !important;"
      >
        <i v-if="isSuccess" style="top:2px !important" class="ico-success"
          ><img  src="@/assets/img/btn-popup-save.png" alt=""
        /></i>
         <i v-else style="top:2px !important" class="ico-success"
          ><img src="@/assets/img/ico-caution.png" alt=""
        /></i>
      <v-row>
      <v-col class="text-center">
        <div v-if="messageTitle" class="text-h6 mb-2">{{ messageTitle }}</div>
        <span v-text="messageText"></span>
      </v-col>
    </v-row>
      <v-card-actions class="d-flex justify-center">
      <v-btn text icon @click="confirmMessage" class="btn">{{ messageConfirmText }}</v-btn>
    </v-card-actions>
      </v-card>
  </v-dialog>
    </div>

    <!-- Loading -->
    <div>
      <v-dialog v-model="loadingDialog" width="300" persistent>
        <v-card class="popup add_store_popup" align="center" justify="center">
          <v-row>
            <v-col>
              <span v-text="loadingText"></span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-progress-linear value="15" indeterminate></v-progress-linear>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </div>
    <!-- 로딩바 레이어 -->
    <div :class="{ loadingLayer: loadingApi, loadingLayerOff: !loadingApi }">
      <div class="loadingBar">
        <v-progress-circular indeterminate :size="50" :width="7" color="#ddd"></v-progress-circular>
      </div>
    </div>
    <VisionNotEnabledModal :visible="showVisionModal" />
  </div>
</template>

<script>
// utils
import EventBus from '@/plugins/eventBus.js'
import commons from '@/plugins/commons'
import configs from '@/plugins/configs'
import codes from '@/plugins/codes'
import { startTokenRefresh, stopTokenRefresh } from '@/plugins/authTokenManager'
import Keycloak from 'keycloak-js/dist/keycloak.js'
import { decryptAES } from '@/plugins/crypto'

// import loadLocaleMessages from '../i18n.js'

// components
import popupStore from './MainPopupStore'
import Navigator from '@/components/Navigator'
import { keepUserSignedIn, clearIntervals } from '@/plugins/healthCheck'
import MainSoftwareInformation from '@/views/MainSoftwareInformation'
import MainPrivacyPolicy from '@/views/MainPrivacyPolicy'
// cloud
import { cloudLogout } from '@/adLogin/authPopup'
// etc
import '@/assets/css/main.css'
import axios from 'axios'
import Cookies from 'js-cookie'
import { debounce } from 'lodash'
import VisionNotEnabledModal from './Vision/model/VisionNotEnabledModal.vue'
const CUSTOMER = configs.Customer

export default {
  name: 'Main',
  components: {
    Navigator,
    popupStore,
    MainSoftwareInformation,
    MainPrivacyPolicy,
    VisionNotEnabledModal
  },
  data () {
    return {
      idleLogoutListenerAttached: false,
      productionType: process.env.VUE_APP_PRODUCTION_TYPE,
      requests: {
        getUser: {
          method: 'get',
          url: '/api/common/account/detail'
        },
        logoutUser: {
          method: 'get',
          url: '/api/common/logout'
        },
        gerreservedData: {
          method: 'get',
          url: '/api/common/articles/map/reserved'
        },
        // toenableLCDtab: {
        //   method: 'get',
        //   url: '/api/common/lcd/check'
        // },
        getStoreSummary: {
          method: 'get',
          url: '/api/common/store/summary'
        }
      },
      searchPublicBarDisabled: false,
      currentLanguage: this.$store.getters['dataStore/GET_CURRENT_LANGUAGE'],
      displayUserId: '',
      drawer: null,
      dialog_store: false,
      messageDialog: false,
      messageText: '',
      messageStatus: '',
      loadingApi: false,
      loadingDialog: false,
      loadingText: '',
      searchStore: {},
      searchStoreLording: null,
      isLoading: false,
      user: {},
      DashBoard_Release: '',
      languagelist: [],
      count: 0,
      MyAccountLink: '/User/MyAccount',
      MenuLogoImage: {},
      MSPStatus: false,
      messageTitle: '',
      messageConfirmText: this.$t('OK'),
      messageOnConfirm: null,
      isSuccess: false, // for message box icon
      isStoreTruncated: false,
      isStoreInfoTruncated: false,
      mobileDrawerOpen: false,
      windowWidth: window.innerWidth
    }
  },
  computed: {
    isMobile () {
      return this.windowWidth < 768
    },
    currentRoute () {
      return this.$route.path
    },
    cloudMode () {
      return this.productionType === 'cloud'
    },
    selectedStore () {
      return this.$store.state.dataStore.selectedStore
    },
    searchStoreItems () {
      return this.$store.state.dataStore.managedStores
    },
    showVisionModal () {
      return this.$store.state.dataStore.showVisionModal
    },
    computedStoreItems () {
      return this.searchStoreItems.map(item => {
        let description = ''
        if (item.company !== null) {
          description += item.company
          if (item.country !== null) {
            description += ' > ' + item.country
            if (item.region !== null) {
              description += ' > ' + item.region
              if (item.city !== null) {
                description += ' > ' + item.city
                if (item.code !== null) {
                  description += ' > ' + item.name + '(' + item.code + ') '
                }
              }
            }
          }
        }
        return Object.assign({}, item, { description })
      })
    },
    selectedStoreText () {
      const selectedStore = this.selectedStore
      if (commons.notEmpty(selectedStore)) {
        const company = commons.isValue(selectedStore.company)
        const country = commons.isValue(selectedStore.country)
        const region = commons.isValue(selectedStore.region)
        const city = commons.isValue(selectedStore.city)
        const code = commons.isValue(selectedStore.code)
        const name = commons.isValue(selectedStore.name)
        return (
          company +
          ' ' +
          country +
          ' ' +
          region +
          ' ' +
          city +
          ' (' +
          name +
          ':' +
          code +
          ') '
        )
      } else {
        return ''
      }
    }
  },
  watch: {
    $route () {
      this.mobileDrawerOpen = false
    },
    selectedStore () {
      this.getTopSearchRefresh()
    },
    async searchStore (store) {
      await this.$store.dispatch('dataStore/UPDATE_SELECTED_STORE', store || {})
      if (store) {
        this.TogetTimezone(store)
        if (this.$route.path.includes('/Vision/')) {
          this.getVisionConfig(store.code)
        }
      } else if (this.$route.path !== '/' && this.$route.path !== '/Template/TemplateTypeList' && this.$route.path !== '/Label/LabelSettings' && this.$route.path !== '/Product/UpdateRecords') {
        this.openSearchStore()
      }
      this.$nextTick(this.checkTruncation)
    },
    searchPublicBarDisabled (disabled) {
      this.$refs.searchIconON.style.display = disabled ? 'none' : 'block'
      this.$refs.searchIconOFF.style.display = disabled ? 'block' : 'none'
    },
    searchStoreLording (val) { }
  },
  created () {
    EventBus.$on('login-success', ({ keycloak, idletime, tokenexpiry }) => {
      this._kcInstance = keycloak
      startTokenRefresh(keycloak, idletime, tokenexpiry)
      this.idleLogout(expiryObj.idletime)
    })
    // NEW: Auto resume refresh after reload
    const storedToken = decryptAES(localStorage.getItem('kc_token')) || ''
    const storedRefresh = decryptAES(localStorage.getItem('kc_refresh_token')) || ''
    const expiryObj = JSON.parse(localStorage.getItem('kc_token_expiry') || '{}')

    if (storedToken && storedRefresh && expiryObj?.idletime && expiryObj?.tokenexpiry && configs.keycloakLogin) {
      const keycloak = new Keycloak({
        url: configs.keycloakurl,
        realm: configs.keycloakrealm,
        clientId: configs.keycloakclientId
      })

      keycloak.init({
        onLoad: 'login-required',
        token: storedToken,
        refreshToken: storedRefresh,
        checkLoginIframe: false
      }).then(auth => {
        if (auth) {
          this._kcInstance = keycloak
          this.$store.commit('auth/UPDATE_TOKEN', keycloak.token)
          startTokenRefresh(keycloak, expiryObj.idletime, expiryObj.tokenexpiry)
          this.idleLogout(expiryObj.idletime)
        } else {
          console.warn('User not authenticated on reload.')
        }
      }).catch(err => {
        console.error('Keycloak re-init failed:', err)
      })
    }
    EventBus.$on('setSearchStore', store => {
      this.searchStoreItems = [store, ...this.searchStoreItems]
      this.searchStore = this.searchStoreItems.shift()
    })
    // open Select Store Popup
    EventBus.$on('openSelectedStores', () => {
      this.openSearchStore()
    })
    // enable Select Store Popup
    EventBus.$on('enableSelectedStores', state => {
      this.searchPublicBarDisabled = !state
    })
    EventBus.$on('setManagedStores', () => {
      this.setManagedStores()
    })
    // open message Alert
    // EventBus.$on('messageAlert', (text, type) => {
    //   if (!type) {
    //     this.messageText = text
    //     this.messageDialog = true
    //   } else if (type === 'YesNo') {
    //     this.messageText = text + type
    //     this.messageDialog = true
    //   }
    // })

    // EventBus.$on('messageAlert', (payload, type) => {
    //   if (typeof payload === 'object') {
    //     this.messageTitle = payload.title || ''
    //     this.messageText = payload.message || this.$t('Something went wrong.')
    //     this.messageConfirmText = payload.confirmText || this.$t('OK')
    //     this.messageOnConfirm = payload.onConfirm || null
    //   } else {
    //     // fallback if payload is undefined/null/empty string
    //     const safeMessage =
    //   typeof payload === 'string' && payload.trim()
    //     ? payload
    //     : this.$t('Something went wrong.')

    //     this.messageTitle = ''
    //     this.messageText = safeMessage
    //     this.messageConfirmText = this.$t('OK')
    //     this.messageOnConfirm = null
    //   }
    //   this.messageDialog = true
    // })

    // EventBus.$on('messageAlert', (payload) => {
    //   if (!payload) return

    //   // force string always
    //   const message =
    // typeof payload === 'string'
    //   ? payload
    //   : payload?.message || ''

    //   if (!message) return

    //   const lower = message.toLowerCase()

    //   if (
    //     lower.includes('token expired') ||
    // lower.includes('unauthorized') ||
    // lower.includes('session expired') ||
    // lower === 'something went wrong'
    //   ) return

    //   this.isSuccess =
    // lower.includes('success') ||
    // lower.includes('saved') ||
    // lower.includes('updated') ||
    // lower.includes('deleted') ||
    // lower.includes('created') ||
    // lower.includes('uploaded') ||
    // lower.includes('completed')

    //   this.messageText = message
    //   this.messageDialog = true
    // })
    EventBus.$on('messageAlert', (payload) => {
      if (!payload) return

      // normalize message
      const message =
    typeof payload === 'string'
      ? payload
      : payload?.message || ''

      if (!message) return

      const lower = message.toLowerCase()

      const skipTokenExpiredPopup =
    lower.includes('token expired') ||
    lower.includes('unauthorized') ||
    lower.includes('session expired') ||
    lower === 'something went wrong'

      // skip duplicate popup
      if (skipTokenExpiredPopup) return

      if (typeof payload === 'object') {
        this.messageTitle = payload.title || ''
        this.messageText = message || this.$t('Something went wrong.')
        this.messageConfirmText = payload.confirmText || this.$t('OK')
        this.messageOnConfirm = payload.onConfirm || null
      } else {
        this.messageTitle = ''
        this.messageText = message || this.$t('Something went wrong.')
        this.messageConfirmText = this.$t('OK')
        this.messageOnConfirm = null
      }

      // success detection
      this.isSuccess =
    lower.includes('success') ||
    lower.includes('saved') ||
    lower.includes('updated') ||
    lower.includes('deleted') ||
    lower.includes('created') ||
    lower.includes('uploaded') ||
    lower.includes('completed')

      this.messageDialog = true
    })
    // loading v-progress-circular on
    EventBus.$on('loadingOn', () => {
      if (!this.loadingApi) this.loadingApi = true
    })
    // loading v-progress-circular off
    EventBus.$on('loadingOff', () => {
      if (this.loadingApi) this.loadingApi = false
    })
    EventBus.$on('toggleLoadingModal', text => {
      this.loadingText = this.$t(text)
      this.loadingDialog = !this.loadingDialog
    })
    EventBus.$on('autoLogout', () => {
      this.onLogout()
    })
  },
  methods: {
    getVisionConfig (store) {
      const config = { params: { stationCode: store } }
      this.$utils.callAxios(codes.requests.getVisionConfig.method, codes.requests.getVisionConfig.url, config)
        .then((res) => {
          if (res.status === 200 && !res.data?.visionEnabled) {
            this.$store.dispatch('dataStore/updateShowVisionModal', true)
          }
        })
        .catch((error) => {
          console.warn(`Could not find Vision Config : ${error}`)
        })
    },
    checkTruncation () {
      const input = this.$refs.storeAutocomplete && this.$refs.storeAutocomplete.$el.querySelector('input')
      this.isStoreTruncated = input ? input.scrollWidth > input.clientWidth : false
      const infoEl = this.$refs.storeInfoRef
      this.isStoreInfoTruncated = infoEl ? infoEl.scrollWidth > infoEl.clientWidth : false
    },
    confirmMessage () {
      this.messageDialog = false
      if (typeof this.messageOnConfirm === 'function') {
        this.messageOnConfirm()
      }
    },
    idleLogout (idletime) {
      let idleTimeout

      function resetTimer () {
        clearTimeout(idleTimeout)
        idleTimeout = setTimeout(triggerLogout, idletime * 1000) // idletime is in seconds
      }

      // function triggerLogout () {
      //   stopTokenRefresh()

      //   // Clear both local and session storage
      //   localStorage.clear()
      //   // sessionStorage.clear()
      //   localStorage.setItem('clear', 'true')

      //   // Delay logout redirect to ensure storage is cleared
      //   setTimeout(() => {
      //     const kctokenhint = decryptAES(localStorage.getItem('kc_id_token')) || ''
      //     let logoutUrl = `${configs.keycloakurl}/realms/${configs.keycloakrealm}/protocol/openid-connect/logout?post_logout_redirect_uri=${window.location.origin}${process.env.BASE_URL}login&client_id=${configs.keycloakclientId}`
      //     if (kctokenhint && kctokenhint.trim()) {
      //       logoutUrl += `&id_token_hint=${kctokenhint}`
      //     }
      //     window.location.href = logoutUrl
      //   }, 100)
      // }
      function triggerLogout () {
        stopTokenRefresh()

        const encryptedToken = localStorage.getItem('kc_id_token')
        const idToken = encryptedToken ? decryptAES(encryptedToken) : ''

        // Resolve BASE_URL injected at build-time by Vue CLI.
        // Fallback to root ('/') if not present.
        let base = '/'
        try {
          if (typeof process !== 'undefined' && process.env && process.env.BASE_URL) {
            base = process.env.BASE_URL
          }
        } catch (e) {
          base = '/'
        }

        // Ensure base ends with a single '/'
        if (!base.endsWith('/')) base = base + '/'

        const redirectUri = window.location.origin + base + 'login'

        let logoutUrl =
    `${configs.keycloakurl}/realms/${configs.keycloakrealm}/protocol/openid-connect/logout` +
    `?client_id=${configs.keycloakclientId}` +
    `&post_logout_redirect_uri=${encodeURIComponent(redirectUri)}`

        if (idToken) {
          logoutUrl += `&id_token_hint=${encodeURIComponent(idToken)}`
        }

        // Clear storage and signal other tabs
        localStorage.clear()
        sessionStorage.clear()
        localStorage.setItem('clear', 'true')

        // Use replace so browser history doesn't keep the logout URL
        window.location.replace(logoutUrl)
      }

      if (!this.idleLogoutListenerAttached) {
        const events = ['mousemove', 'mousedown', 'touchstart', 'click', 'keydown', 'scroll']
        events.forEach(event => {
          window.addEventListener(event, resetTimer, true)
        })
        this.idleLogoutListenerAttached = true
      }

      // Start the initial timer
      resetTimer()
    },
    getTopSearchRefresh () {
      var getSelectedStore = this.$store.state.dataStore.selectedStore.code
      for (const gt of this.computedStoreItems) {
        if (gt.code === getSelectedStore) {
          this.searchStore = gt
        }
      }
    },
    // To get initial all language list
    togetlanguagelist () {
      const config = { params: {} }
      this.$utils
        .callAxios(
          codes.requests.getLanguageList.method,
          codes.requests.getLanguageList.url,
          config
        )
        .then((res) => {
          if (res.data) {
            console.log(res.data)
            this.languagelist = res.data.languageList
            const userSubscriptionKey = this.languagelist[0].languageId
            const indexOfObject = this.languagelist.findIndex(
              (o) => o.languageId === userSubscriptionKey
            )
            if (localStorage.getItem('languagecontent') === null) {
              this.setActive(this.languagelist[0], indexOfObject)
            }
            if (localStorage.getItem('languagecontent') !== null) {
              console.log(this.$store.getters['dataStore/GET_CURRENT_LANGUAGE'])
              const obj = {
                languageName: this.$store.getters['dataStore/GET_CURRENT_LANGUAGE']
              }
              const datavalue = this.languagelist.filter(function (person) { return person.languageName === obj.languageName })
              this.togetlanguagecontent(datavalue[0].languageId)
            }
          }
        })
        .catch((error) => {
          console.warn(`Could not find any Language List : ${error}`)
        })
    },

    // Active class
    setActive (subscription) {
      console.log(subscription)
      // this.activeIndex = index
      // this.languagelist[index].languageId = subscription.languageId
      this.currentLanguage = subscription.languageName
      this.togetlanguagecontent(subscription.languageId)
    },
    // To get language content
    togetlanguagecontent: debounce(function (id) {
      console.log(this.$store.getters['dataStore/GET_CURRENT_LANGUAGE'])
      // })
      // if (code === undefined) {
      //   code = this.$store.getters['dataStore/GET_CURRENT_LANGUAGE']
      // }
      console.log(id)
      const config = {
        params: {
          languageId: id,
          export: null,
          contents: true
        }
      }
      this.$utils
        .callAxios(
          codes.requests.getLanguageContent.method,
          codes.requests.getLanguageContent.url,
          config
        )
        .then((res) => {
          if (res.data) {
            console.log(res.data)
            console.log(res.config)
            console.log(this.$i18n._vm._data.messages.lan)
            localStorage.setItem('languagecontent', res.data.content)
            this.$i18n.locale = 'lan'
            this.$i18n._vm._data.messages.lan = JSON.parse(localStorage.getItem('languagecontent'))
            this.currentLanguage = res.data.languageName
            this.$store.dispatch('dataStore/UPDATE_CURRENT_LANGUAGE', res.data.languageName)
            console.log(this.$store.getters['dataStore/GET_CURRENT_LANGUAGE'])

            this.$forceUpdate()
          }
        })
        .catch((error) => {
          console.warn(`Could not find any Language content : ${error}`)
        })
    }, 300),

    changLanguage (code) {
      if (code === undefined) {
        code = this.$store.getters['dataStore/GET_CURRENT_LANGUAGE']
      }
      let codeName = ''
      switch (code) {
        case 'en':
          codeName = 'English'
          break
        case 'ko':
          codeName = '한국어'
          break
        case 'de':
          codeName = 'Deutsche'
          break
        case 'fr':
          codeName = 'Francais'
          break
        case 'zh':
          codeName = '中文'
          break
        case 'es':
          codeName = 'Espanol'
          break
        case 'it':
          codeName = 'Italiano'
          break
        case 'por':
          codeName = 'Portugal'
          break
        case 'jp':
          codeName = '日本語'
          break
        default:
          codeName = 'English'
          code = 'en'
      }
      this.$i18n.locale = code
      this.currentLanguage = codeName
      this.$store.dispatch('dataStore/UPDATE_CURRENT_LANGUAGE', code)
      this.$forceUpdate()
    },
    processCloudLogout () {
      this.$store
        .dispatch('auth/logout')
        .then(res => {
          this.$store.dispatch('dataStore/CLEAN')
          cloudLogout()
        })
        .catch(error => {
          this.$store.dispatch('dataStore/CLEAN')
          this.loading = false
          this.message = error.message
        })
    },
    onLogout: debounce(function () {
      if (this.productionType === 'cloud') {
        this.processCloudLogout()
        return
      }
      // Preserve language content and current language before logout
      const languageContent = localStorage.getItem('languagecontent')
      const currentLanguage = this.$store.getters['dataStore/GET_CURRENT_LANGUAGE']

      const params = { account: this.user.account }
      const config = { params: params }
      this.$utils
        .callAxios(
          this.requests.logoutUser.method,
          this.requests.logoutUser.url,
          config
        )
        .finally(() => {
          this.$store
            .dispatch('auth/logout')
            .catch(error => {
              this.loading = false
              this.message = error.message
            })
            .finally(() => {
              this.RemoveSelectedStore()
              this.$store.dispatch(
                'dataStore/updateStaySignedIn',
                false
              )
              clearIntervals()
              this.$store.dispatch('dataStore/CLEAN')
              this.$store.dispatch('dataStore/RESETSTATE')
              // Keycloak Based Logout
              if (configs.keycloakLogin === true) {
                const kctokenhint = decryptAES(localStorage.getItem('kc_id_token')) || ''
                let logoutUrl = configs.keycloakurl + '/realms/' + configs.keycloakrealm + '/protocol/openid-connect/logout?post_logout_redirect_uri=' + window.location.origin + process.env.BASE_URL + 'login' + '&client_id=' + configs.keycloakclientId
                if (kctokenhint && kctokenhint.trim()) {
                  logoutUrl += '&id_token_hint=' + kctokenhint
                }
                localStorage.clear()
                localStorage.setItem('clear', 'true')
                // Restore language content and current language after clearing storage
                if (languageContent) {
                  localStorage.setItem('languagecontent', languageContent)
                }
                if (currentLanguage) {
                  this.$store.dispatch('dataStore/UPDATE_CURRENT_LANGUAGE', currentLanguage)
                }
                window.location.href = logoutUrl
              } else {
                this.$router.push('/login')
              }
              // Clear both local and session storage
              localStorage.clear()
              localStorage.setItem('clear', 'true')
              // Restore language content and current language after clearing storage
              if (languageContent) {
                localStorage.setItem('languagecontent', languageContent)
              }
              if (currentLanguage) {
                this.$store.dispatch('dataStore/UPDATE_CURRENT_LANGUAGE', currentLanguage)
              }
              Cookies.remove('accountName', { path: '' })
              // Cookies.remove('EmailUpdateLater', { path: '' })
            })
        })
    }, 300),
    getContentWrapWidth () {
      var offsetWidth = document.getElementById('contentWrap')?.clientWidth
      this.contentWidth = `${offsetWidth + 25}px`
    },
    handleResize () {
      var offsetWidth = document.getElementById('contentWrap')?.clientWidth
      this.contentWidth = `${offsetWidth + 25}px`
    },
    RemoveSelectedStore () {
      const store = this.$store.state.dataStore.selectedStore
      if (store.company === undefined) store.company = ''
      store.country = ''
      store.region = ''
      store.city = ''
      store.code = ''
      store.name = ''
      store.description = ''
      return store
    },
    closeModal (state) {
      this.dialog_store = state
    },
    closeMainStoreModal (store, state) {
      this.dialog_store = state
      if (store && !commons.isNull(store.code)) this.searchStore = store
    },
    openSearchStore () {
      this.dialog_store = true
    },
    searchStoreFilter (item, queryText, itemText) {
      const itemStore = item.description.toLowerCase()
      const searchText = queryText.toLowerCase()
      return itemStore.indexOf(searchText) > -1
    },
    autoComplateSearch (val) { },
    toggleDropdown (event) {
      // / added due to only call the language api only
      // when language dropdown is opened
      if (
        event.target.name === 'language-dropdown' &&
        !event.target.classList.contains('isOpenend')
      ) {
        this.togetlanguagelist()
      }
      event.target.classList.toggle('isOpenend')
      // 09.27 버튼 외 화면 클릭시 메뉴 안보이게 처리
      document.addEventListener('click', function (e) {
        if (e.target !== event.target) {
          event.target.classList.remove('isOpenend')
        }
      })
    },
    getUserInfo () {
      this.user = this.$store.state.auth.user
      if (this.productionType === 'cloud') {
        this.displayUserId = this.$store.state.auth.user.tokenEmail
      } else {
        this.displayUserId = this.$store.state.auth.user.account
      }
    },
    setManagedStores () {
      const config = {
        params: {
          account: this.$store.state.auth.user.account,
          company: this.$store.state.auth.user.account.company
        }
      }
      this.$utils
        .callAxios(
          this.requests.getUser.method,
          this.requests.getUser.url,
          config
        )
        .then(res => {
          const data = res.data
          this.$store.dispatch('dataStore/UPDATE_MANAGED_STORE', data)
          EventBus.$emit('setMainPopupCompany')
        })
    },
    getMSPStatus () {
      const url = '/metro/msp-status'
      const vuex = JSON.parse(localStorage.getItem('vuex'))
      var config = {}
      if (configs.keycloakLogin === true) {
        config = {
          headers: { 'api-key': configs.ApiKey, Authorization: `Bearer ${vuex.auth.tokenAPI}` }
        }
      }
      axios.get(configs.ServerAddress + url, config)
        .then(response => {
          console.log(response)
          if (response.data.msp_enabled === false) {
            this.MSPStatus = true
          } else {
            this.MSPStatus = false
          }
          localStorage.setItem('MSPStatus', this.MSPStatus)
        }).catch(err => {
          console.log(err)
          this.MSPStatus = false
        })
    },
    gerreservedData () {
      const config = { params: {} }
      this.$utils
        .callAxios(
          this.requests.gerreservedData.method,
          this.requests.gerreservedData.url,
          config
        )
        .then(res => {
          const data = res.data
          console.log(data)
          localStorage.setItem('reservedItems', JSON.stringify(data))
        })
    },
    // toenableLCDtab () {
    //   const config = { params: {} }
    //   this.$utils
    //     .callAxios(
    //       this.requests.toenableLCDtab.method,
    //       this.requests.toenableLCDtab.url,
    //       config
    //     )
    //     .then(res => {
    //       const data = res.data
    //       console.log(data.lcdtab)
    //       const arr = [data]
    //       console.log(arr[0])

    //       localStorage.setItem('LcdTabEnable', data)
    //     })
    //     .catch(err => {
    //       console.log(err)
    //       console.log(err.response.status)
    //       localStorage.setItem('LcdTabEnable', 'false')
    //       this.$forceUpdate()
    //     })
    // },
    TogetTimezone: debounce(function (data) {
      if (data.code !== '' || data.code !== null) {
        const params = { store: data.code, isLabelAlive: configs.isLabelAlive }
        const config = { params }
        this.$utils
          .callAxios(
            this.requests.getStoreSummary.method,
            this.requests.getStoreSummary.url,
            config
          )
          .then(res => {
            this.$store.dispatch('dataStore/updateTimezone', res.data.zoneId)
          })
      }
    }, 300)
  },
  mounted () {
    console.log('ismobile:>> ', this.isMobile)
    // localStorage.setItem('LcdTabEnable', 'false')
    if (this.productionType === 'cloud') {
      this.MyAccountLink = '/User/MyAccountCloud'
    }
    if (this.$store.state.dataStore.staySignedIn) keepUserSignedIn()
    this.DashBoard_Release = configs.Release
    // this.changLanguage()
    this.searchStore = this.$store.getters['dataStore/GET_SELECTED_STORE']
    this.getUserInfo()
    this.togetlanguagelist()
    this.MenuLogoImage = this.$store.state.dataStore.MenuLogoImage
    if (CUSTOMER === 'METRO') {
      this.getMSPStatus()
      this.gerreservedData()
    }
    this.getContentWrapWidth()
    this._onResize = () => { this.windowWidth = window.innerWidth }
    window.addEventListener('resize', this._onResize)

    if (configs.keycloakLogin === true) {
      this._visibilityHandler = () => {
        if (document.visibilityState !== 'visible') return
        const kc = this._kcInstance
        if (!kc || !kc.refreshToken) return
        kc.updateToken(-1).catch(() => {
          this.onLogout()
        })
      }
      document.addEventListener('visibilitychange', this._visibilityHandler)
    }

    // this.toenableLCDtab()
  },
  beforeDestroy () {
    console.log('called beforeDestroy:>> ')
    window.removeEventListener('resize', this._onResize)
    if (this._visibilityHandler) {
      document.removeEventListener('visibilitychange', this._visibilityHandler)
    }
    EventBus.$off('login-success')
    EventBus.$off('setSearchStore')
    EventBus.$off('openSelectedStores')
    EventBus.$off('enableSelectedStores')
    EventBus.$off('setManagedStores')
    EventBus.$off('messageAlert')
    EventBus.$off('loadingOn')
    EventBus.$off('loadingOff')
    localStorage.removeItem('kc_token')
    localStorage.removeItem('kc_refresh_token')
    localStorage.removeItem('kc_token_expiry')
    stopTokenRefresh()
    commons.clearVuex()
  },
  destroyed () {
    clearIntervals()
  }
}
</script>

<style scoped>
.custom-autocomplete::v-deep.v-input {
  flex: 0;
}

.custom-autocomplete ::v-deep .v-input__icon--clear .v-icon {
  background-color: #09263f;
  color: #fff !important;
  border-radius: 50%;
  padding: 2px;
  font-size: 16px;
  opacity: 1;
  margin-left: 10px;
}

.custom-autocomplete ::v-deep .v-input__icon--clear .v-icon:hover {
  background-color: #09263f;
}

.custom-autocomplete ::v-deep input {
  field-sizing: content;
  min-width: 80px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.h_lang {
  width: 100px !important;
}

.h_storeInfo {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
}

/* Hamburger button — hidden on desktop */
.btn-mobile-menu {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  flex-shrink: 0;
  width: 24px;
  height: 18px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  margin-right: 12px;
}
.btn-mobile-menu span {
  display: block;
  height: 2px;
  background-color: #fff;
  border-radius: 2px;
}

/* Mobile overlay backdrop */
.mobile-nav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

@media (max-width: 768px) {
  .navigation {
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1000 !important;
    width: 96px !important;
  }
  .navigation.drawer-open {
    transform: translateX(0);
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.3);
  }
  .contentsWarp {
    width: 100% !important;
    margin-left: 0 !important;
  }
  .btn-mobile-menu {
    display: flex;
  }
}
</style>
<style>
.v-tooltip-resize {
  width: 200px;
  word-break: break-word;
}

.v-tooltip__content {
  background: #001e38;
  color: #fff;
}

@media (max-width: 768px) {
  body .wrapper {
    min-width: unset !important;
  }
}
</style>
